import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import Footer from "../Components/Footer.js"
import '../CSS/Template.css'
import AppointmentService from '../utils/AppointmentService.js';
import Message from "../Components/Message.js"
import {$,jQuery} from 'jquery';

const styles = {
 list: {
   width: 250,
 },
 fullList: {
   width: 'auto',
 },
};

class MessagesContainer extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      bottom: false,
      messages: [],
      unread: false
    };
    this.Appt = new AppointmentService()
  }


 componentDidMount(){
   this.Appt.messages().then(res =>{
    this.setState({
      messages: res.messages
      })
    })
    .catch(err =>{

    })
    this.getMessages()
 }
 sendMessage(textbox){
   var text = textbox.value
   textbox.value = ""
   this.Appt.sendMessage(text).then(res =>{
     this.setState({
       messages: res.messages
     })
     this.scrollSmoothToBottom()
  // $('#messageSection').animate({scrollBottom: 10000}, 'slow');
   })
   .catch(err =>{

   })
 }
 scrollSmoothToBottom () {
   var objDiv = document.getElementById('messageSection')
   if(objDiv)
    objDiv.scrollTop = objDiv.scrollHeight;
 }
 _handleKeyPress = (e) => {
   if (e.key === 'Enter') {
   }
 }
 toggleDrawer = (side, open) => () => {
   if(this.state.messages){
     this.state.messages.forEach(message => {
       message.read_by_customer = true
     })
   }
   this.setState({
     unread: false,
     [side]: open,
   });
 };
 getMessages(){
   var appt = this.Appt
   var outer_this = this

   setInterval(function(){
        var readCount = 0
        appt.messages().then(res =>{
         outer_this.setState({
           messages: res.messages
         })
         outer_this.state.messages.forEach(message => {
           if(message.read_by_customer == "true"){
             readCount ++;
           }
         })
         if(readCount < outer_this.state.messages.length){
           outer_this.setState({
             unread: true
           })
         }
       })
       .catch(err =>{
           console.error("Cannot retrieve messages", err)
      })
   }, 20000);

 }
 clearMessages() {
   if(this.state.messages && this.state.messages.length > 0)
   this.Appt.clearMessages(this.state.messages[this.state.messages.length - 1].id).then(res =>{
     this.setState({
       messages:[]
     })
   })
   .catch(err =>{

   })
 }
 render() {
   const { classes } = this.props;

   const sideList = (
     <div className={classes.list}>
      <h1>Test</h1>
     </div>
   );

   const fullList = (
     <div className={classes.fullList}>
      <h1>Test</h1>
     </div>
    );
     var messagesHTML = []
     if(this.state.messages && this.state.messages.length > 0){
     this.state.messages.forEach((message, index) => {
         messagesHTML.push(<Message key={index} message={message} />)
       });
     }
       // <div className="twoColumn">
       //
       //   <a onClick={() => this.clearMessages()} className="clearMessageButton">Clear Message</a>
       // </div>
   return (
     <div>
     <div onClick={this.toggleDrawer('bottom', true)}><Footer unread={this.state.unread}/></div>
       <Drawer
         anchor="bottom"
         docked={true}
         open={this.state.bottom}
         onClose={this.toggleDrawer('bottom', false)}
       >
         <div
           tabIndex={0}
           className="messagesCont"
           role="button"
         >
         <div className="footerReplica">

           <div className="clickableDiv" onClick={this.toggleDrawer('bottom', false)}>
                <center><p>Message Spiffy</p></center>
           </div>

          </div>
           <div ref={el => { this.el = el; }} id="messageSection">
             <ul className="messageList">
              {messagesHTML}
             </ul>
           </div>
          <input placeholder="Type a message, press enter to Send." className="messageInput" ref='reference' onKeyPress={(e) => {(e.key === 'Enter' ? this.sendMessage(e.target) : null)}} />
         </div>
       </Drawer>
     </div>
   );
 }
}

MessagesContainer.propTypes = {
 classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(MessagesContainer);



// WEBPACK FOOTER //
// ./src/Components/MessagesContainer.js